module.exports = __webpack_public_path__ + "static/media/ils-file-pdf.87fbfbe6.svg";